import React, { useState, useEffect } from 'react';
import { Fab, Tooltip, useTheme, useMediaQuery } from '@mui/material';
import { Add as AddIcon, Speed as SpeedIcon } from '@mui/icons-material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import SecureStorageService from '../../services/secureStorageService';

const QuickActionFab = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  const navigate = useNavigate();
  const { propertyId } = useParams();
  const { accounts } = useMsal();
  
  const [userRoles, setUserRoles] = useState([]);
  const [showFab, setShowFab] = useState(false);

  useEffect(() => {
    const roles = SecureStorageService.getRoles() || [];
    setUserRoles(roles);
  }, []);

  useEffect(() => {
    const isAuthenticated = accounts && accounts.length > 0;
    const isPropertyPage = location.pathname.includes('/property/');
    const isPartnerAdmin = userRoles.includes('PartnerAdmin');
    const isGuestTripsPage = location.pathname.includes('/guest-trips');
    
    // Show FAB on property pages for PartnerAdmins, but not on guest-trips page (since it has its own create button)
    setShowFab(isAuthenticated && isPropertyPage && isPartnerAdmin && !isGuestTripsPage);
  }, [location.pathname, userRoles, accounts]);

  const handleFabClick = () => {
    if (propertyId) {
      navigate(`/property/${propertyId}/guest-trips`);
    } else {
      // Fallback: navigate to guides page
      navigate('/guides');
    }
  };

  if (!showFab) {
    return null;
  }

  return (
    <Tooltip title="Create Guest Trip" placement="left">
      <Fab
        color="primary"
        onClick={handleFabClick}
        sx={{
          position: 'fixed',
          bottom: { xs: 80, md: 32 }, // Higher on mobile to avoid bottom navigation area
          right: { xs: 16, md: 32 },
          zIndex: theme.zIndex.speedDial,
          '&:hover': {
            transform: 'scale(1.1)',
          },
          transition: 'all 0.3s ease',
        }}
      >
        <AddIcon />
      </Fab>
    </Tooltip>
  );
};

export default QuickActionFab;
